export default "__VITE_ASSET__dzO1ydRx__"